import { cn } from "@newxsystems/shared";
import { SproutCommonContent } from "../../../../modules/content/components/SproutCommonContent/SproutCommonContent";
import { SproutMedia } from "../../../../modules/content/components/SproutMedia/SproutMedia";
import { SproutSection } from "../../../../modules/content/components/SproutSection/SproutSection";
import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import type { ITextMediaBlockProps } from "./TextMediaBlock.props";

export const TextMediaBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  direction,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
  video,
}: ITextMediaBlockProps) => {
  const videoDestination =
    video?.source === "direct"
      ? video.directVideo
      : video?.source === "youtube"
        ? video.youtubeVideo
        : video?.vimeoVideo;
  const hasCopy = Boolean(eyebrow || heading || description || buttons?.length);
  if (!image && !videoDestination) return null;
  const media = (
    <div className="sprout-paper-lift flex min-w-0 rotate-[0.45deg] flex-col gap-4 rounded-[1.5rem_1.5rem_1.5rem_0.35rem] border-[0.55rem] border-whiteboard bg-whiteboard">
      {image ? (
        <SproutMedia
          aspectRatio={image.aspectRatio || "16:9"}
          media={image.image}
          sizes="(min-width: 768px) 50vw, 100vw"
        />
      ) : null}
      {video && videoDestination ? (
        <VideoPlayer
          banner={video.banner}
          directVideo={video.directVideo}
          source={video.source}
          vimeoVideo={video.vimeoVideo}
          youtubeVideo={video.youtubeVideo}
        />
      ) : null}
    </div>
  );
  return (
    <SproutSection className={parentClass} id={anchorId} spacing={spacing}>
      {hasCopy ? (
        <div className="sprout-dot-field sprout-sky-lift grid items-center gap-8 rounded-[2rem_2rem_2rem_0.5rem] border-2 border-navy-ink p-5 md:grid-cols-2 md:gap-8 md:p-8 lg:gap-10">
          <div
            className={cn(
              "sprout-workbook-paper order-1 flex min-w-0 items-center rounded-[1.5rem_1.5rem_1.5rem_0.35rem] border-2 border-navy-ink p-7 md:p-10",
              direction === "ltr" && "md:order-2",
            )}
          >
            <SproutCommonContent
              alignment={alignment}
              buttons={buttons}
              description={description}
              eyebrow={eyebrow}
              heading={heading}
            />
          </div>
          <div className={cn("order-2 min-w-0", direction === "ltr" && "md:order-1")}>{media}</div>
        </div>
      ) : (
        media
      )}
    </SproutSection>
  );
};

TextMediaBlock.displayName = "Block::TextMediaBlock";
